import React, { useState } from "react";

const AirportJsonConverter = () => {
    const [convertedData, setConvertedData] = useState(null);

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onload = (e) => {
            try {
                const jsonData = JSON.parse(e.target.result);

                const formatted = jsonData
                    .filter((item) => !item[0].startsWith("#")) // header skip
                    .map((item) => ({
                        airportCode: item[0],
                        airportName:
                            item[1]
                                .toLowerCase()
                                .replace(/\b\w/g, (char) => char.toUpperCase()) +
                            " Airport",
                        lat_long: [parseFloat(item[2]), parseFloat(item[3])],
                    }));

                setConvertedData(formatted);
            } catch (error) {
                alert("Invalid JSON file!");
            }
        };

        reader.readAsText(file);
    };

    const handleDownload = () => {
        const blob = new Blob([JSON.stringify(convertedData, null, 2)], {
            type: "application/json",
        });

        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "airport_converted.json";
        a.click();
        URL.revokeObjectURL(url);
    };

    return (
        <div style={{ padding: "20px" }}>
            <h2>Airport JSON Converter</h2>

            <input type="file" accept=".json" onChange={handleFileUpload} />

            {convertedData && (
                <>
                    <h3 style={{ marginTop: "20px" }}>Preview (First 3)</h3>
                    <pre>
                        {JSON.stringify(convertedData.slice(0, 3), null, 2)}
                    </pre>

                    <button
                        onClick={handleDownload}
                        style={{
                            marginTop: "15px",
                            padding: "8px 16px",
                            cursor: "pointer",
                        }}
                    >
                        Download Converted JSON
                    </button>
                </>
            )}
        </div>
    );
};

export default AirportJsonConverter;